module.exports = __webpack_public_path__ + "img/3.55221a1a.jpg";